import React, { FC } from 'react';
import { Modal, ModalBody, ModalClose, Box, Text, ButtonAppearance, Icon, IconSize, theme } from '@bechtel/gds';
import { DrawerFooterButtonStyled, ProjectAppTypes, useEnvProvider } from '@bechtel/client-common';
import {
  RemoveImportUsersModelBlockStyled,
  RemoveImportUsersModelActionBlockStyled,
  ImportUsersItemContainerStyled,
  ImportUsersItemStyled,
  ModalHeaderStyled,
  ModalFooterStyled,
} from './styled';
import { CrewType } from '@bechtel/types';
import { t, Trans } from '@lingui/macro';

interface RemoveCrewTypesModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  crewTypesToRemove: CrewType[];
}

const RemoveCrewTypesModal: FC<RemoveCrewTypesModalProps> = ({ onCancel, onConfirm, crewTypesToRemove }) => {
  const { envConfig } = useEnvProvider();
  const isPFAppType = envConfig.appName === ProjectAppTypes.PF;
  return (
    <Modal visible={true} style={{ width: '552px', height: '510px' }}>
      <ModalHeaderStyled title={t`Remove Access`}>
        <ModalClose onClick={onCancel}></ModalClose>
      </ModalHeaderStyled>
      <ModalBody>
        <Box
          flexDirection={{ sm: 'column' }}
          justifyContent={{ sm: 'flex-start' }}
          alignItems={{ sm: 'flex-start' }}
          flexGrow={{ sm: '1' }}
        >
          {crewTypesToRemove && (
            <RemoveImportUsersModelBlockStyled>
              <Icon icon="exclamation-triangle" size={IconSize.LARGE} />
              <Box ml={{ sm: '450' }}>
                <Text size="500" family="graphik" color="grey.1000" weight="600">
                  <Trans>You are about to remove access for</Trans> {crewTypesToRemove.length}{' '}
                  {crewTypesToRemove.length > 1 ? t`Crew Types` : t`Crew Type`}.
                </Text>
              </Box>
            </RemoveImportUsersModelBlockStyled>
          )}
          <Box
            flexDirection={{ sm: 'column' }}
            css={`
              overflow-y: auto;
            `}
          >
            <RemoveImportUsersModelActionBlockStyled flexDirection={{ sm: 'column' }}>
              <Box mb={{ sm: '500' }}>
                <Text size="400" weight="600" family="graphik" color="grey.1000">
                  <Trans>This action cannot be undone.</Trans>
                </Text>
              </Box>
              <Text style={{ lineHeight: `${theme.spacings[550]}` }} size="400" family="graphik" color="grey.1000">
                {t`All Crews in ${
                  isPFAppType ? 'PipeFighter' : 'ArcStryker'
                } from the following Crew Types will have their ${
                  isPFAppType ? 'PipeFighter' : 'ArcStryker'
                } access removed. Are you sure you want to do this?`}
              </Text>
            </RemoveImportUsersModelActionBlockStyled>
            <ImportUsersItemContainerStyled>
              {crewTypesToRemove &&
                crewTypesToRemove.map((item, index) => {
                  return (
                    <ImportUsersItemStyled key={index}>
                      <Text size="400" color="grey.600">
                        {item.name} - {item.description}
                      </Text>
                    </ImportUsersItemStyled>
                  );
                })}
            </ImportUsersItemContainerStyled>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooterStyled>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
              <Box px={{ sm: '500' }}>
                <Trans>Cancel</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
          <Box>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onConfirm}>
              <Box px={{ sm: '500' }}>
                <Trans>Remove Crews</Trans>
              </Box>
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooterStyled>
    </Modal>
  );
};

export default RemoveCrewTypesModal;
